import { render, staticRenderFns } from "./CandidateProcessNumber.vue?vue&type=template&id=255b93f1&scoped=true&"
import script from "./CandidateProcessNumber.vue?vue&type=script&lang=js&"
export * from "./CandidateProcessNumber.vue?vue&type=script&lang=js&"
import style0 from "./CandidateProcessNumber.vue?vue&type=style&index=0&id=255b93f1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b93f1",
  null
  
)

export default component.exports